export default function PageNotFound() {
	return (
		<div className='flex-1 d-flex justify-content-center align-items-center'>
			<span className='fs-1 me-2'>404</span>
			<span className='fs-5'>Página no encontrada.</span>
		</div>
	)
}
